<template>
    <div
        :id="id"
        :aria-labelledby="id"
        class="modal fade pt-popin-cds"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-ob1-component="Popin"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content pb-0 px-1 px-md-2">
                <div
                    v-if="radioButtonOfferSelected"
                    :key="radioButtonOfferSelected.idSeo"
                >
                    <!--/* header */-->
                    <div class="modal-header">
                        <Lien
                            v-if="activeView !== 'offer-content'"
                            id="back-button"
                            :is-button="true"
                            :is-mini="true"
                            :is-link-arrow-back="true"
                            :label="'Retour'"
                            @click="goBack"
                        />
                        <button
                            type="button"
                            class="btn-close pt-2 pt-md-0"
                            data-bs-dismiss="modal"
                            aria-label="Fermer"
                            style="display: block !important"
                        >
                            <span class="icon icon-delete" aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            class="btn-close ob1-link-arrow back"
                            data-bs-dismiss="modal"
                            style="display: none !important"
                        >
                            Fermer
                        </button>
                    </div>
                    <!--/* content */-->
                    <div class="modal-body px-0">
                        <div class="row">
                            <div class="col-12 px-2 px-md-3 px-lg-5">
                                <!--/* DETAILS de l'offre */-->
                                <div v-if="activeView === 'offer-content'">
                                    <!--/* header offre */-->
                                    <div class="row">
                                        <div class="col-10">
                                            <strong
                                                v-if="showBanner(radioButtonOfferSelected.banner)"
                                                v-msh-html="radioButtonOfferSelected.banner"
                                                class="ob1-tag ob1-tag-primary mb-1"
                                            />
                                            <h2 class="visually-hidden">
                                                {{ nameAccessibility }}
                                            </h2>
                                            <p class="fw-bold py-0 mb-0" aria-hidden="true">
                                                {{ radioButtonOfferSelected.offerType }}
                                            </p>
                                            <h2 class="h1 py-0 mb-0" aria-hidden="true">
                                                {{ radioButtonOfferSelected.secondaryShortLabel }}
                                            </h2>
                                        </div>
                                        <div class="col-2 d-flex justify-content-end">
                                            <img
                                                v-if="radioButtonOfferSelected.is5G"
                                                :src="logo5gSrc"
                                                alt="logo 5G Orange"
                                                class="logo-5g-popin"
                                                aria-hidden="true"
                                            >
                                            <img
                                                v-else-if="radioButtonOfferSelected.is5GPlus"
                                                :src="logo5gPlusSrc"
                                                alt="logo 5G+ Orange"
                                                class="logo-5g-popin"
                                                aria-hidden="true"
                                            >
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div v-if="getNewSubMessage(radioButtonOfferSelected)" class="col-12 text-gray3 fw-bold">
                                            {{ getNewSubMessage(radioButtonOfferSelected) }}
                                        </div>
                                        <div class="col-12">
                                            <div :class="isShowOpenDiscountMessage ? 'my-1 px-1 bg-greige' : 'my-1 mb-0'">
                                                <template v-if="isShowOpenDiscountMessage">
                                                    <div
                                                        class="fw-bold small text-dark pt-1 pb-0 pe-1"
                                                        v-html="radioButtonOfferSelected.openDiscountMessage"
                                                    />
                                                </template>
                                                <div>
                                                    <PriceWithDetails
                                                        class="price-align"
                                                        :price="radioButtonOfferSelected.price"
                                                        :price-details-popin="radioButtonOfferSelected.priceDetailsPopin"
                                                        :offer-id-seo="radioButtonOfferSelected.idSeo"
                                                        :offer-name="radioButtonOfferSelected.name"
                                                        :tracking-category="'popin_detail_offre'"
                                                        :is-embedded-details="true"
                                                        @show-details="showPriceDetails"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="radioButtonOfferSelected.monthlyOdrs && !radioButtonOfferSelected.priceDetailsPopin" class="col-12">
                                            <ul class="row list-unstyled mb-0" aria-label="Offres de réductions mensuelles du forfait">
                                                <li v-for="(odr, index) in radioButtonOfferSelected.monthlyOdrs" :key="index">
                                                    <InlinePromise
                                                        :key="index"
                                                        :claim="{ attributes: { textHtml: odr } }"
                                                        :is-warning="true"
                                                        :compact-text="true"
                                                    />
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            v-if="radioButtonOfferSelected.claims && radioButtonOfferSelected.claims.length > 0"
                                            :class="radioButtonOfferSelected.priceDetailsPopin ? 'col-12 pt-1' : 'col-12'"
                                        >
                                            <ul class="row list-unstyled mb-0" aria-label="Avantages du forfait">
                                                <li v-for="(claim, index) in radioButtonOfferSelected.claims" :key="`claim-${index}`">
                                                    <InlinePromise :claim="claim" />
                                                </li>
                                            </ul>
                                        </div>

                                        <div
                                            v-if="blockedUnBlockedOffer"
                                            id="version-blocked-selection"
                                        >
                                            <div class="lead fw-bold pt-2 pb-0">
                                                {{ radioButtonOfferSelected.miniOfferCdsTypeLabel }}
                                            </div>
                                            <ob1-radio-button-list
                                                :with-column-layout="true"
                                                :radios-buttons="radioButtonBlockedUnBlockedDTO"
                                                @change="onVersionChange"
                                            />
                                        </div>

                                        <div>
                                            <ob1-message-alerte
                                                v-if="radioButtonOfferSelected.alreadyInCartOfferLabel"
                                                type="success"
                                                :title="radioButtonOfferSelected.alreadyInCartOfferLabel"
                                            />
                                        </div>
                                    </div>

                                    <!--/* attributs accordion */-->
                                    <div class="row mb-4">
                                        <div class="col-12">
                                            <div class="accordion" itemscope="" itemtype="https://schema.org/FAQPage">
                                                <div
                                                    v-for="(detailAttribute, attributeIndex) in radioButtonOfferSelected.detailAttributes"
                                                    :key="`${radioButtonOfferSelected.idSeo}-${attributeIndex}`"
                                                    class="card multi"
                                                    itemscope=""
                                                    itemprop="mainEntity"
                                                    itemtype="https://schema.org/Question"
                                                >
                                                    <div class="card-header">
                                                        <button
                                                            :id="`faqQuestion-${radioButtonOfferSelected.idSeo}-${attributeIndex}`"
                                                            class="collapsed"
                                                            data-bs-toggle="collapse"
                                                            :data-bs-target="`#faqAnswer-${radioButtonOfferSelected.idSeo}-${attributeIndex}`"
                                                            :aria-controls="`faqAnswer-${radioButtonOfferSelected.idSeo}-${attributeIndex}`"
                                                            aria-expanded="false"
                                                            type="button"
                                                        >
                                                            <div class="accordion-card-title">
                                                                <p class="accordion-title mb-0" itemprop="name">
                                                                    <span>{{ detailAttribute.titleAttribute }}</span>
                                                                </p>
                                                                <p class="accordion-icon mb-0" aria-hidden="true" />
                                                            </div>
                                                        </button>
                                                    </div>
                                                    <div
                                                        :id="`faqAnswer-${radioButtonOfferSelected.idSeo}-${attributeIndex}`"
                                                        class="collapse"
                                                        :aria-labelledby="`faqQuestion-${radioButtonOfferSelected.idSeo}-${attributeIndex}`"
                                                        role="region"
                                                        itemscope
                                                        itemprop="acceptedAnswer"
                                                        itemtype="https://schema.org/Answer"
                                                    >
                                                        <div class="accordion-card-body standard" itemprop="text" v-html="detailAttribute.textAttribute" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--/* Mentions légales  */-->
                                    <div v-if="radioButtonOfferSelected.legalMentions" class="pb-2">
                                        <ob1-liens-haut-bas
                                            :button-id="radioButtonOfferSelected.legalMentions.title.headerId"
                                            :button-label="radioButtonOfferSelected.legalMentions.title.title"
                                            :collapsed-block-id="radioButtonOfferSelected.idSeo + '-' + radioButtonOfferSelected.legalMentions.title.textId"
                                        >
                                            <div v-for="(mention, index) in radioButtonOfferSelected.legalMentions.mentions" :key="'mentiontext-' + radioButtonOfferSelected.idSeo + '-' + index">
                                                <strong v-if="mention.title">{{ mention.title }}</strong>
                                                <span v-if="mention.text" v-html="mention.text" />
                                            </div>
                                        </ob1-liens-haut-bas>
                                    </div>
                                </div>

                                <!--/* DETAILS du prix de l'offre */-->
                                <div v-if="activeView === 'price-content'">
                                    <PriceDetailsContent
                                        :id="id"
                                        :offer-type="offerType"
                                        :offer-name="offerName"
                                        :offer-price="radioButtonOfferSelected.price"
                                        :price-details="radioButtonOfferSelected.priceDetailsPopin"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sticky-bottom py-2 bg-white modal-footer d-flex justify-content-center">
                        <ob1-boutons
                            v-if="shouldOpenRemiseInternetPopin"
                            :key="'cta-remise-' + ctaRenderKey"
                            class="mx-0 px-0 w-100"
                            :is-button="true"
                            :is-primary="true"
                            :label="getCtaLabel(radioButtonOfferSelected)"
                            data-bs-toggle="modal"
                            :data-bs-target="'#remise-offers-open-modal'"
                            :data-offer-seo-id="radioButtonOfferSelected && radioButtonOfferSelected.idSeo"
                            :data-oevent-category="'overlay_cta'"
                            :data-oevent-action="getLabelToTmsFormat(getCtaLabel(radioButtonOfferSelected))"
                            :data-oevent-label="getLabelToTmsFormat(radioButtonOfferSelected.name)"
                        />
                        <offer-cta-with-device-popin
                            v-else-if="isAddOfferWithPopin"
                            :key="'cta-with-device-' + ctaRenderKey"
                            :is-wide="false"
                            :is-primary="true"
                            :from-cds="true"
                            :label="getCtaLabel(radioButtonOfferSelected)"
                            :offer-name="radioButtonOfferSelected.name"
                            :offer-seo-id="radioButtonOfferSelected.idSeo"
                            :popin-id="'addOfferWithDevicePopIn-' + radioButtonOfferSelected.idSeo"
                            :popin-ctas-dto="radioButtonOfferSelected.addOfferDto.popinWithDeviceCdsDto"
                            :tracking-category="'overlay_forfait'"
                            :tracking-label="getLabelToTmsFormat(radioButtonOfferSelected.name)"
                            @add-to-cart-success="onAddToCartSuccess"
                            @add-to-cart-error="onAddToCartError"
                        />
                        <ob1-boutons
                            v-else-if="radioButtonOfferSelected.addOfferDto"
                            :key="'cta-link-' + ctaRenderKey"
                            :is-button="false"
                            :is-primary="true"
                            :is-wide="false"
                            :label="getCtaLabel(radioButtonOfferSelected)"
                            :href="radioButtonOfferSelected.addOfferDto.link"
                            :data-oevent-category="'overlay_cta'"
                            :data-oevent-action="getLabelToTmsFormat(getCtaLabel(radioButtonOfferSelected))"
                            :data-oevent-label="getLabelToTmsFormat(radioButtonOfferSelected.name)"
                        />

                        <offer-cta-with-device-popin
                            v-if="radioButtonOfferSelected.addOfferWithAuthenticationDto"
                            :key="'cta-auth-' + ctaRenderKey"
                            :is-wide="false"
                            :is-primary="true"
                            :from-cds="true"
                            :label="getCtaLabel(radioButtonOfferSelected)"
                            :offer-name="radioButtonOfferSelected.name"
                            :offer-seo-id="radioButtonOfferSelected.idSeo"
                            :popin-id="'addOfferWithAuthenticationAndDevicePopIn-' + radioButtonOfferSelected.idSeo"
                            :popin-ctas-dto="radioButtonOfferSelected.addOfferWithAuthenticationDto.popinWithDeviceCdsDto"
                            :tracking-category="'overlay_cta'"
                            :tracking-label="getLabelToTmsFormat(radioButtonOfferSelected.name)"
                            @add-to-cart-success="onAddToCartSuccess"
                            @add-to-cart-error="onAddToCartError"
                        />
                        <ob1-boutons
                            v-if="radioButtonOfferSelected.addOfferInCartDto"
                            :key="'cta-cart-' + ctaRenderKey"
                            class="mx-0 px-0 w-100"
                            :is-button="true"
                            :is-primary="true"
                            :label="radioButtonOfferSelected.addOfferInCartDto.label"
                            data-oevent-category="tuile_forfait_vsim"
                            data-oevent-action="ajouter_au_panier"
                            :data-oevent-label="radioButtonOfferSelected.name"
                            @ob1-boutons-click.prevent="onAddOfferInCart()"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InlinePromise from "../../../../common/components/ob1/InlinePromise.vue";
import OfferCtaWithDevicePopin from "../../../common/offerdetails/OfferCtaWithDevicePopin.vue";
import Lien from "../../../../common/components/ob1/Lien.vue";
import PriceDetailsContent from "./PriceDetailsContent.vue";
import PriceWithDetails from "../../../../common/components/custom/PriceWithDetails.vue";

export default {
    components: {
        PriceWithDetails,
        PriceDetailsContent,
        Lien,
        OfferCtaWithDevicePopin,
        InlinePromise
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        offers: {
            type: Array,
            required: true
        },
        logo5gSrc: {
            type: String,
            required: true
        },
        logo5gPlusSrc: {
            type: String,
            required: true
        },
        newSubSeoIds:{
            type: Array,
            required: true
        },
        newSubMessage: {
            type: String,
            required: false,
            default: null
        },
        showRemiseInternetPopin: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            activeView: 'offer-content',
            radioButtonOfferSelected: null
        }
    },
    computed: {
        blockedUnBlockedOffer() {
            return this.radioButtonOfferSelected?.blocked !== undefined;
        },
        radioButtonBlockedUnBlockedDTO() {
            if (this.blockedUnBlockedOffer) {
                return [
                    {
                        radioButtonDTO: {
                            id: "version-blocked",
                            name: "version",
                            label: "blocked",
                            checked: this.radioButtonOfferSelected.blocked,
                            ariaLabelledBy: "blocked",
                            value: "blocked",
                        },
                        primaryText: this.radioButtonOfferSelected.miniOfferCdsTypeBlocked

                    },
                    {
                        radioButtonDTO: {
                            id: "version-no",
                            name: "version",
                            label: "notBlocked",
                            checked: !this.radioButtonOfferSelected.blocked,
                            ariaLabelledBy: "neuf-label",
                            value: "not blocked"
                        },
                        primaryText: this.radioButtonOfferSelected.miniOfferCdsTypeUnBlocked
                    }
                ]
            } else return []
        },
        isShowOpenDiscountMessage() {
            return this.radioButtonOfferSelected?.openDiscountMessage !== undefined
                && (this.radioButtonOfferSelected?.priceDetailsPopin === undefined
                    || this.radioButtonOfferSelected?.priceDetailsPopin === null)
        },
        shouldOpenRemiseInternetPopin() {
            return this.showRemiseInternetPopin
                && this.radioButtonOfferSelected
                && this.radioButtonOfferSelected.fmr;
        },
        isAddOfferWithPopin() {
            return this.radioButtonOfferSelected?.addOfferDto?.popinWithDeviceCdsDto;
        },
        ctaRenderKey() {
            if (!this.radioButtonOfferSelected) {
                return 'empty';
            }

            const addOfferLink = this.radioButtonOfferSelected.addOfferDto
                ? this.radioButtonOfferSelected.addOfferDto.link
                : '';

            return [
                this.radioButtonOfferSelected.idSeo,
                this.radioButtonOfferSelected.blocked,
                addOfferLink,
            ].join('-');
        },
        nameAccessibility() {
            let label5GAccessibility = this.radioButtonOfferSelected.is5G ? '5G' : '';
            let brandAccessibility = this.radioButtonOfferSelected.brand === 'ORANGE' ? 'Forfait Orange' : 'Forfait Sosh';

            let secondaryShortLabelAccessibility = this.radioButtonOfferSelected.secondaryShortLabel
                ? this.radioButtonOfferSelected.secondaryShortLabel
                    .replace(/Mo/g, ' méga Octet')
                    .replace(/Go/g, ' giga Octet')
                : '';

            return this.radioButtonOfferSelected.type + ' ' + brandAccessibility +  ' ' + this.radioButtonOfferSelected.offerType + ' ' + secondaryShortLabelAccessibility + ' ' + label5GAccessibility;
        },
        offerName() {
            return this.radioButtonOfferSelected.secondaryShortLabel || this.radioButtonOfferSelected.name;
        },
        offerType() {
            return this.radioButtonOfferSelected.offerType || "";
        },
    },
    mounted() {
        const modalElement = document.getElementById(this.id);
        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', this.onModalHidden);
        }
    },
    beforeDestroy() {
        const modalElement = document.getElementById(this.id);
        if (modalElement) {
            modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden);
        }
    },
    methods: {
        onAddOfferInCart() {
          this.$emit('add-offer-in-cart', this.radioButtonOfferSelected.idSeo);
        },
        onAddToCartSuccess(event) {
            if (window.$ && this.$el) {
            const $modal = window.$(this.$el).closest('.modal');
            if ($modal?.length) {
              $modal.modal('hide');
            }
          }
          this.$emit('add-offer-in-cart-success', event);
        },
        onAddToCartError(event) {
          this.$emit('add-offer-in-cart-error', event);
        },
        getNewSubMessage(selectedOffer) {
            if (selectedOffer && this.newSubSeoIds.includes(selectedOffer.idSeo)) {
                return this.newSubMessage;
            }
            return null;
        },
        getCtaLabel(offer) {
            return offer.ctaCdsChoiceOfferLabel
        },
        getLabelToTmsFormat(label) {
            let blockedUnBlockedLabel = '';
            if (this.blockedUnBlockedOffer) {
                blockedUnBlockedLabel = this.radioButtonOfferSelected.blocked ? '_bloque' : '_non_bloque';
            }

            return stripAccents(label).split(' ').join('_') + blockedUnBlockedLabel;
        },

        getBlockedUnBlockedVersion(offer) {
            let unBlockedVersion = offer  && this.offers
                && this.offers.filter(o => o.idSeo === offer.equivalentBlockedOrUnblockedVersionIdSeo)
            return unBlockedVersion && unBlockedVersion.length > 0 ? unBlockedVersion[0] : null
        },
        onVersionChange() {
            // Récupérer l'offre correspondante bloquée/non-bloquée depuis la liste des offres
            const currentOfferId = this.radioButtonOfferSelected.idSeo;
             const equivalentOfferId = this.radioButtonOfferSelected.equivalentBlockedOrUnblockedVersionIdSeo;
             const equivalentOffer = this.offers.find(o => o.idSeo === equivalentOfferId);

             if (equivalentOffer) {
                 this.radioButtonOfferSelected = equivalentOffer;
                 let action = this.radioButtonOfferSelected.blocked ? 'version_bloquee' : 'version_non_bloquee';
                 let label = stripAccents(this.radioButtonOfferSelected.name).split(' ').join('_');
                 Tms.link({category: "overlay_forfait", action: action, label: label});
                 this.$emit('change-offer-blocked', {
                     blocked: this.radioButtonOfferSelected.blocked,
                     offerIdSeo: this.radioButtonOfferSelected.idSeo,
                     equivalentOfferIdSeo: currentOfferId,
                 });
             }
         },
        showBanner(banner) {
            return banner && banner !== '';
        },
        goBack() {
            if (this.activeView === 'price-content') {
                this.activeView = 'offer-content';
            }
        },
        showPriceDetails() {
            this.activeView = 'price-content';
        },
        onModalHidden() {
            this.activeView = 'offer-content';
        },

    },

}
</script>
<style scoped lang="scss">
@media (max-width: 767px) {
    .pt-popin-cds {
        padding-top: 110px !important;
    }
}
.btn-close::before {
    display: none !important;
}
.modal-dialog .modal-header {
    position: inherit !important;
}
.modal-dialog .modal-header.box-shadow {
    box-shadow: none !important;
}

.logo-5g-popin {
    position: absolute;
    top: 0;
    width: 50px;
}

//Une classe ajoutée provisoir pour la partie promo du forfait
.ob1-price .ob1-price-promo-duration {
    display: inline;
}

// correctif accordion border dernier element
.accordion .card.multi:last-child .card-header button {
    border-bottom: 0;
}
.accordion .card.multi:last-child {
    border-bottom: 1px solid #ccc;
}
</style>
